import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/vercel/path0/src/components/CopyButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/vercel/path0/src/components/ShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimilarPrompts"] */ "/vercel/path0/src/components/SimilarPrompts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/vercel/path0/src/components/ui/badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/vercel/path0/src/components/ui/separator.tsx");
